// extracted by mini-css-extract-plugin
module.exports = {"section":"_13Of5","fadeIn":"_3zf1D","image":"_99Bef","imageImg":"_2G3Aa","title":"_3QzPu"};